export default "__VITE_ASSET__f5b54b0c__"